import http from "@http"
import OSS from 'ali-oss'

let API = {
    //获取sts_token
    GET_STS_TOKEN : "/oss/sts-token"
}
export function getStsToken(data){
    return http.get(API.GET_STS_TOKEN , data)
}
export function getFileExtension(filename) {
    const dotIndex = filename.lastIndexOf('.')
    return dotIndex > 0 ? filename.slice(dotIndex + 1) : ''
}
export function genUniqueName(file) {
    const subfix = getFileExtension(file.name);
    const timestamp = new Date().toISOString().replace(/[-:.]/g,'').slice(0, 14)
    const random = Math.random().toString(36).substring(2, 6)
    return `file_${timestamp}_${random}.`+subfix
}
export async function initOSSClient() {
    const res = await getStsToken();
    return new OSS({
    region: 'oss-cn-huhehaote',
    accessKeyId: res.data.accessKeyId,
    accessKeySecret: res.data.accessKeySecret,
    stsToken: res.data.securityToken,
    bucket: 'jfxt-01',
    refreshSTSToken: true 
    })
}
export async function uploadImage(file){
    const client = await initOSSClient()
    const fileName = genUniqueName(file);
    client.put(fileName, file)
    return fileName;
}

export async function deleteImage(path){
    const client = await initOSSClient()
    return client.delete(path);
}

//const url1 = client.signatureUrl('target_folder/img1.jpg') const url2 = client.signatureUrl('target_folder/img2.jpg')
